export default __webpack_public_path__ + "static/media/favorite-user.b4ff94d7.svg";